import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import LogoWhiteShape from '@/components/common/svg/shapes/LogoWhiteShape.tsx';
import {
  containerStyles,
  contentHeaderStyles,
  contentMessageStyles,
  contentStyles
} from '@/components/Verification/styles.ts';

const EmptyLikesList = () => {
  const { t } = useTranslation();

  return (
    <div style={containerStyles}>
      <div style={{ ...contentStyles, top: 'calc(50% - 40px)' }}>
        <div style={circleStyle}>
          <LogoWhiteShape
            width={90}
            height={90}
            fillColor="#fff"
            style={logoStyle}
          />
          <div style={smallDotBottomStyle}></div>
          <div style={mediumDotStyle}></div>
          <div style={smallDotTopStyle}></div>
        </div>
        <span style={contentHeaderStyles}>
          {t('likes.empty.placeholder.title')}
        </span>
        <p style={contentMessageStyles}>
          {t('likes.empty.placeholder.subtitle')}
        </p>
      </div>
    </div>
  );
};

const circleStyle: CSSProperties = {
  width: '112px',
  height: '112px',
  borderRadius: '60px',
  background: 'rgb(202 204 211)',
  position: 'relative',
  marginBottom: '15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const logoStyle: CSSProperties = {
  width: '70px',
  height: '70px'
};

const smallDotBottomStyle: CSSProperties = {
  position: 'absolute',
  width: '10px',
  height: '10px',
  borderRadius: '5px',
  background: 'rgb(202 204 211)',
  left: '-25px',
  top: '92px'
};

const mediumDotStyle: CSSProperties = {
  position: 'absolute',
  width: '20px',
  height: '20px',
  borderRadius: '10px',
  background: 'rgb(202 204 211)',
  left: '-30px',
  top: '32px'
};

const smallDotTopStyle: CSSProperties = {
  position: 'absolute',
  width: '10px',
  height: '10px',
  borderRadius: '5px',
  background: 'rgb(202 204 211)',
  right: '-25px',
  top: '12px'
};

export default EmptyLikesList;
